// extracted by mini-css-extract-plugin
export default {"wrapper":"Pagination_wrapper__PTyNs","btn":"Pagination_btn__1Lm8s","disabled":"Pagination_disabled__1Yp6+","num":"Pagination_num__yU2PX","numActive":"Pagination_numActive__2Is45"};